import { useKeycloak } from "@react-keycloak/web";
import type React from "react";
import { type FC, useMemo } from "react";
import { AdminUserRole, CustomerUserRole, LeadAssessorUserRole } from "../api/dto";
import { AuthenticatedLayout } from "../components/layout/AuthenticatedLayout";
import {
  UnauthenticatedPlaceholder,
  UnauthorizedPlaceholder,
} from "../components/layout/UnauthenticatedPlaceholder";

export const AuthMiddleware: FC<{ children: React.ReactNode }> = ({ children }) => {
  const { keycloak } = useKeycloak();
  const roles = useMemo(
    () => keycloak.tokenParsed?.realm_access?.roles ?? [],
    [keycloak.tokenParsed],
  );
  if (!keycloak.authenticated) {
    return <UnauthenticatedPlaceholder />;
  }
  if (
    !roles.includes(AdminUserRole) &&
    !roles.includes(LeadAssessorUserRole) &&
    !roles.includes(CustomerUserRole)
  ) {
    return <UnauthorizedPlaceholder />;
  }
  return <AuthenticatedLayout>{children}</AuthenticatedLayout>;
};
